import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import axios from "axios";
import AppShell from "./components/layout/AppShell";
import HomePage from "./pages/HomePage";
import StatePage from "./pages/StatePage";
import DadosPage from "./pages/DadosPage";
import PoliticaPage from "./pages/PoliticaPage";
import PoliticoDetailPage from "./pages/PoliticoDetailPage";
import NoticiasPage from "./pages/NoticiasPage";
import NoticiaDetailPage from "./pages/NoticiaDetailPage";
import CleptocraciaPage from "./pages/CleptocraciaPage";
import FutDoPovoPage from "./pages/FutDoPovoPage";
import GasPage from "./pages/GasPage";
import MedPage from "./pages/MedPage";
import MedFacilityPage from "./pages/MedFacilityPage";
import AdminPedidosPage from "./pages/AdminPedidosPage";
import MunicipioDetailPage from "./pages/MunicipioDetailPage";
import OAuthCallback from "./pages/OAuthCallback";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import StocksPage from "./pages/StocksPage";
import CompanyListPage from "./pages/CompanyListPage";
import CompanyPage from "./pages/CompanyPage";

// Configuração global do Axios - usa variável de ambiente em produção
const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:5174/api";
axios.defaults.baseURL = API_BASE;

// Google Analytics - ID da métrica
const GA_MEASUREMENT_ID = "G-6G5PVVDF87";

function AppContent() {
  const location = useLocation();
  // Rastreia mudanças de página no Google Analytics
  useEffect(() => {
    // Verifica se gtag está disponível (carregado no index.html)
    if (typeof window.gtag === "function") {
      window.gtag("config", GA_MEASUREMENT_ID, {
        page_path: location.pathname + location.search,
        page_title: document.title,
      });
    }
  }, [location]);

  return (
    <AppShell currentPath={location.pathname}>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/dados" element={<DadosPage />} />
        <Route path="/stocks" element={<StocksPage />} />
        <Route path="/companies" element={<CompanyListPage />} />
        <Route path="/companies/:cdcvm" element={<CompanyPage />} />
        <Route path="/politica" element={<PoliticaPage />} />
        <Route path="/politica/candidato/:sqCandidato" element={<PoliticoDetailPage />} />
        <Route path="/noticias" element={<NoticiasPage />} />
        <Route path="/noticias/:slug" element={<NoticiaDetailPage />} />
        <Route path="/cleptocracia" element={<CleptocraciaPage />} />
        <Route path="/futdopovo" element={<FutDoPovoPage />} />
        <Route path="/gas" element={<GasPage />} />
        <Route path="/med" element={<MedPage />} />
        <Route path="/med/:cnes" element={<MedFacilityPage />} />
        <Route path="/admin/pedidos" element={<AdminPedidosPage />} />
        <Route path="/estado/:stateSigla/:year?" element={<StatePage />} />
        <Route path="/municipio/:codigoIbge" element={<MunicipioDetailPage />} />
        <Route path="/auth/callback" element={<OAuthCallback />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
      </Routes>
    </AppShell>
  );
}

function App() {
  return (
    <HelmetProvider>
      <Router>
        <AppContent />
      </Router>
    </HelmetProvider>
  );
}

export default App;
